import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PillComponent {
  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  @Input() small: boolean = false;
}
